import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {BrregCompany, CompanySearchResponse} from '../../models/company.model';

/**
 * Service for interacting with company data
 * This service handles Brreg company data and import operations
 */
@Injectable({
  providedIn: 'root'
})
export class CompanyService {
    private apiService = inject(ApiService);


  /**
   * Retrieves a company from Brreg by its organization number
   * @param orgNumber The organization number of the company
   * @param clientId The client ID to retrieve the company for
   * @returns An Observable with the Brreg company
   */
  getCompanyByOrgNumber(orgNumber: string, clientId: string): Observable<BrregCompany> {
    return this.apiService.get<BrregCompany>(`companies/brreg/${orgNumber}`, { clientId });
  }

  /**
   * Searches for companies in Brreg based on filters
   * @param searchParams The search parameters
   * @param clientId The client ID to search companies for
   * @returns An Observable with bounded results and the total matching count
   */
  searchCompanies(searchParams: any, clientId: string): Observable<CompanySearchResponse> {
    return this.apiService.post<CompanySearchResponse>('companies/brreg/search', searchParams, { clientId });
  }

  /**
   * Imports a company from Brreg to HubSpot
   * @param orgNumber The organization number of the company to import
   * @param clientId The client ID to import the company for
   * @returns An Observable with the import result
   */
  importCompany(orgNumber: string, clientId: string): Observable<any> {
    return this.apiService.post<any>(`companies/import/${orgNumber}`, {}, { clientId });
  }

  /**
   * Imports multiple companies from Brreg to HubSpot
   * @param orgNumbers An array of organization numbers to import
   * @param clientId The client ID to import the companies for
   * @returns An Observable with the import result
   */
  importBatch(orgNumbers: string[], clientId: string): Observable<any> {
    return this.apiService.post<any>('companies/import-batch', { orgNumbers }, { clientId });
  }
}
